<div class="custom-page-column pdf-page app-il-09-35-07-02" id="il350702">
  <p class="font-small text-end"><b>IL 09 35 07 02</b></p>
  <p class="font-medium" style="text-align: center">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ IT CAREFULLY. </b>
  </p>
  <p class="font-large" style="text-align: center">
    <b>EXCLUSION OF CERTAIN COMPUTER-RELATED LOSSES</b>
  </p>

  <p class="font-small">
    This endorsement modifies insurance provided under the following:
  </p>
  <p class="font-small ps-10">
    COMMERCIAL INLAND MARINE COVERAGE PART<br />
    COMMERCIAL PROPERTY COVERAGE PART<br />
    CRIME AND FIDELITY COVERAGE PART<br />
    STANDARD PROPERTY POLICY
  </p>

  <table class="font-small">
    <tbody>
      <tr>
        <td style="width: 50%; vertical-align: top;">
          <ol type="A">
            <li style="font-weight: bold; padding-bottom: 10px;">
              <span style="font-weight: normal;">
              We will not pay for loss ("loss") or damage caused directly or
              indirectly by the following. Such loss ("loss") or damage is
              excluded regardless of any other cause or event that contributes
              concurrently or in any sequence to the loss ("loss") or damage.
              <ol>
                <li style="font-weight: bold; padding-bottom: 10px; padding-top: 5px;">
                  <span style="font-weight: normal;">
                  The failure, malfunction or inadequacy of:
                  <ol type="a">
                    <li style="font-weight: bold; padding-bottom: 10px; padding-top: 5px;">
                      <span style="font-weight: normal;">
                      Any of the following, whether belonging to any insured or
                      to others:
                      <ol class="custom-list">
                        <li style="padding-bottom: 5px; padding-top: 5px;">Computer hardware, including microprocessors;</li>
                        <li style="padding-bottom: 5px;">Computer application software;</li>
                        <li style="padding-bottom: 5px;">
                          Computer operating systems and related software;
                        </li>
                        <li style="padding-bottom: 5px;">Computer networks;</li>
                        <li style="padding-bottom: 5px;">
                          Microprocessors (computer chips) not part of any
                          computer system; or
                        </li>
                        <li style="padding-bottom: 5px;">
                          Any other computerized or electronic equipment or
                          components; or
                        </li>
                      </ol>
                      </span>
                    </li>
                    <li style="font-weight: bold; padding-bottom: 10px;">
                      <span style="font-weight: normal;">
                      Any other products, and any services, data or functions
                      that directly or indirectly use or rely upon, in any
                      manner, any of the items listed in Paragraph
                      <b>A.1.a.</b> of this endorsement;
                      </span>
                    </li>
                  </ol>
                  due to the inability to correctly recognize, process,
                  distinguish, interpret or accept one or more dates or times.
                  An example is the inability of computer software to recognize
                  the year 2000.
                  </span>
                </li>
              </ol>
              </span>
            </li>
          </ol>
        </td>
        <td style="width: 50%; vertical-align: top;">
          <ol type="A" start="2">
            <ol start="2">
              <li style="font-weight: bold; padding-bottom: 10px;">
                <span style="font-weight: normal;">
                Any advice, consultation, design, evaluation, inspection,
                installation, maintenance, repair, replacement or supervision
                provided or done by you or for you to determine, rectify or test
                for, any potential or actual problems described in Paragraph
                <b>A.1.</b> of this endorsement.
                </span>
              </li>
            </ol>
            <li style="font-weight: bold; padding-bottom: 10px;">
              <span style="font-weight: normal;">
              If an excluded Cause of Loss as described in Paragraph
              <b>A.</b> of this endorsement results:
              <ol>
                <li style="font-weight: bold; padding-bottom: 10px; padding-top: 5px;">
                  <span style="font-weight: normal;">
                  In a Covered Cause of Loss under the Crime and Fidelity
                  Coverage Part, the Commercial Inland Marine Coverage Part or
                  the Standard Property Policy; or
                  </span>
                </li>
                <li style="font-weight: bold; padding-bottom: 10px;">
                  <span style="font-weight: normal;">
                  Under the Commercial Property Coverage Part:
                  <ol type="a">
                    <li style="padding-bottom: 10px; padding-top: 5px;">
                      In a "Specified Cause of Loss", or in elevator collision
                      resulting from mechanical breakdown, under the Causes of
                      Loss – Special Form; or
                    </li>
                    <li style="padding-bottom: 10px;">
                      In a Covered Cause of Loss under the Causes Of Loss –
                      Basic Form or the Causes Of Loss – Broad Form;
                    </li>
                  </ol>
                  </span>
                </li>
              </ol>
              we will pay only for the loss ("loss") or damage caused by such
              "Specified Cause of Loss", elevator collision, or Covered Cause of
              Loss.
              </span>
            </li>
            <li style="font-weight: bold; padding-bottom: 10px;">
              <span style="font-weight: normal;">
              We will not pay for repair, replacement or modification of any
              items in Paragraphs <b>A.1.a.</b> and <b>A.1.b.</b> of this
              endorsement to correct any deficiencies or change any features.
            </span>
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>
